module.exports = __webpack_public_path__ + "img/claim-icon-close.cafe906b.svg";